import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { Bell, Download, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ZoneAlertsPanel = ({ prefs, provinces, filters, onSaved }) => {
  const [enabled, setEnabled] = useState(prefs?.enabled ?? false);
  const [selected, setSelected] = useState(prefs?.provinces || []);
  const [saving, setSaving] = useState(false);

  const toggle = (p) => setSelected((s) => (s.includes(p) ? s.filter((x) => x !== p) : [...s, p]));

  const save = async () => {
    setSaving(true);
    try {
      const res = await axios.put(`${API}/building-zones/alerts`, { enabled, provinces: selected }, { withCredentials: true });
      onSaved?.(res.data);
      toast.success(enabled ? 'Alertes activées' : 'Alertes désactivées');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur');
    } finally {
      setSaving(false);
    }
  };

  const exportCsv = () => {
    const params = new URLSearchParams();
    if (filters.province) params.append('province', filters.province);
    params.append('months', filters.months);
    window.open(`${API}/building-zones/export.csv?${params.toString()}`, '_blank');
  };

  return (
    <Card data-testid="zone-alerts-panel">
      <CardContent className="p-5 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-heading font-bold text-lg flex items-center gap-2"><Bell className="w-5 h-5 text-[#F59E0B]" /> Alertes nouvelles zones</h3>
          <Switch checked={enabled} onCheckedChange={setEnabled} data-testid="zone-alerts-switch" />
        </div>
        <p className="text-xs text-[#6B7280]">Recevez un email à chaque mise à jour mensuelle avec les nouveaux lotissements autorisés dans vos provinces.</p>
        <div className="flex flex-wrap gap-2">
          {provinces.map((p) => (
            <button
              key={p} type="button" onClick={() => toggle(p)}
              className={`px-2.5 py-1 rounded-full text-xs border transition-colors ${selected.includes(p) ? 'bg-[#1E3A8A] text-white border-[#1E3A8A]' : 'bg-white text-[#374151] border-gray-200 hover:border-[#1E3A8A]'}`}
              data-testid={`zone-alert-province-${p}`}
            >{p}</button>
          ))}
        </div>
        <p className="text-[11px] text-[#9CA3AF]">Aucune province sélectionnée = toute la Wallonie.</p>
        <div className="flex gap-2">
          <Button size="sm" className="bg-[#1E3A8A] flex-1" onClick={save} disabled={saving} data-testid="save-zone-alerts-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Enregistrer'}
          </Button>
          <Button size="sm" variant="outline" onClick={exportCsv} data-testid="zone-export-btn"><Download className="w-4 h-4 mr-1" /> Export CSV</Button>
        </div>
      </CardContent>
    </Card>
  );
};
